// Retargeting pixel tags
export const JIVOX_PIXEL_URL = {
  onLandingPageLoad: 'https://pxl.jivox.com/tags/re/pxrc.php?px=m968087d72h2sS&ret=img&gdpr=null&gdpr_consent=null',
  onGetStartedClick: 'https://pxl.jivox.com/tags/re/pxrc.php?px=IlH7k43b7nTkeu&ret=img&cData=Get_started&gdpr=null&gdpr_consent=null',
  onShowContactForm: 'https://pxl.jivox.com/tags/re/pxrc.php?px=F0wacI2g0eUY90&ret=img&cData=Lets_connect&gdpr=null&gdpr_consent=null',
  onFormSubmit: 'https://pxl.jivox.com/tags/conv/pxre.php?px=8vPBbCN3K9OKXK&rev=0'
}

// Convertion pixel tags
export const JIVOX_CONVERTIONS_URL = {
  onGetStartedClick: 'https://pxl.jivox.com/tags/conv/pxjs.php?px=vbizsOqrCCGuWy&rev=0&gdpr=null&gdpr_consent=null&cOpt=landing|LandingPage',
  onEveryPageLoad: 'https://pxl.jivox.com/tags/conv/pxjs.php?px=NiR3xMMvvD7Fso&rev=0&gdpr=null&gdpr_consent=null',
  onSummaryPageLoad: 'https://pxl.jivox.com/tags/conv/pxjs.php?px=zDM0XQfMSMncR2&rev=0&gdpr=null&gdpr_consent=null&cOpt=symmary|SummaryPage',
}
